import { jsonArray, jsonObject, jsonString } from "./decode"

/** Exact committed deletions; safe to apply again after newer messages arrive. */
export type TranscriptReset = { sessionID: string; messageIDs: string[] }

export function decodeTranscriptReset(value: unknown): TranscriptReset {
  const reset = jsonObject(value, "Invalid transcript reset")
  return {
    sessionID: jsonString(reset.sessionID, "Invalid transcript reset session"),
    messageIDs: jsonArray(reset.messageIDs, "Invalid transcript reset messages")
      .map((id) => jsonString(id, "Invalid transcript reset message")),
  }
}
